<div *ngIf="enableFilePreviewer" class="file-preview__uploaded-document">
  <skychute-uploaded-document *ngFor="let file of myFiles"
                              [data]="file"
                              [isLoading]="file.uploadingInProgress"
                              [isReadOnly]="file.uploadingInProgress"
                              (deleteFile)="fileRemove.emit(file)"
  ></skychute-uploaded-document>
</div>
